<template>
  <div>
    <a-card style="margin: 20px">
      <template #title>
        <div class="top-title">
          <div class="left">
            <span>发票管理</span>
          </div>

          <div class="right-flex">
            <!-- 第一行：选择器 -->
            <div class="selectors">
              <departmentChoose :department-code.sync="form.departmentCode" @change="departmentChange"></departmentChoose>
              <a-select placeholder="请选择商户" :dropdownMatchSelectWidth="false" v-model.trim="form.mchNo"
                        :filter-option="filterOption" :show-search="true" @change="getMchShopListApi"
                        style="min-width: 300px; margin-left: 10px;">
                <a-select-option v-for="item in mchNolist" :title="item.label" :key="item.value" :value="item.value">
            <span>
              <a-tag color="purple">融</a-tag>{{ item.value }}-{{ item.label }}
              <br/>
              <a-tag color="blue" v-if="item.fatherName">控</a-tag>{{ item.fatherName || "" }}
            </span>
                </a-select-option>
              </a-select>
            </div>

            <!-- 第二行：汇总数据 + 全量同步按钮 -->
            <div class="statistics-summary" style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
<!--              <div>-->
<!--                <p>发票池总额度：￥{{ invoicePoolData?.totalLimit || 0.00 }}</p>-->
<!--                <p>结算可用额度（已匹配额度）：￥{{ invoicePoolData?.settleAvailLimit || 0.00 }}</p>-->
<!--              </div>-->
              <div style="margin-left: auto;">
                <a-button type="primary" @click="handleSyncAll" v-if="$authority('invoiceSyncAll')">
                  全量同步
                </a-button>
              </div>
            </div>


          </div>
        </div>
      </template>

      <div class="loan">
        <div class="search">
          <a-form :model="form" layout="inline">
            <a-form-item label="登记日期">
              <a-range-picker
                  @change="onChange"
                  :default-value="defaultDateRange"
              />
            </a-form-item>
            <a-form-model-item label="发票编号">
              <a-input style="width: 200px" v-model="form.invoiceNo" placeholder="请输入票号"/>
            </a-form-model-item>
            <a-form-item label="到账状态">
              <a-select v-model="form.normalStatus" style="min-width: 100px; ">
                <a-select-option value=""> 全部</a-select-option>
                <a-select-option v-for="(item,index) in matchStatus" :key="index" :value="item.value">
                  <a-tag :color="item.color">{{ item.text }}</a-tag>
                </a-select-option>

              </a-select>
            </a-form-item>
            <br/>
            <a-form-item label="金额范围">
              <a-input-group compact>
                <input-balance style="width: 173px" v-model="form.invoiceAmountStart" placeholder="最低金额"></input-balance>
                <input-balance style="width: 173px" v-model="form.invoiceAmountEnd" placeholder="最高金额"></input-balance>
              </a-input-group>
            </a-form-item>
            <a-form-item label="结算账号">
              <a-select
                  :dropdownMatchSelectWidth="false" placeholder="请选择结算账号"
                  :show-search="true" v-model="form.collAccountNo"
                  style="min-width: 200px;">
                <a-select-option v-for="item in shoplist" :key="item.value" :value="item.value">
                  <div style="display: flex; justify-content: space-between">
                    <span>{{ item.collAccountName }}</span>
                    <code style="color: grey;font-size: 0.8em">{{ item.collAccountNo }}</code></div>
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="清算状态">
              <a-select v-model="form.clearStatus" style="min-width: 100px; ">
                <a-select-option value=""> 全部</a-select-option>
                <a-select-option v-for="(item,index) in settleStatus" :key="index" :value="item.value">
                  <a-tag :color="item.color">{{ item.text }}</a-tag>
                </a-select-option>
              </a-select>
            </a-form-item>


            <a-form-item>
              <a-button type="primary" @click="search" icon="search">查询</a-button>
            </a-form-item>
          </a-form>
        </div>
        <div class="Applyfor">
          <a-button @click="add" type="primary" v-if="$authority('invoiceAdd')" icon="plus"> 发票登记</a-button>
          <a-button @click="settleCurrPage" type="primary"  v-if="$authority('settleCurrPage')" icon="thunderbolt"> 清算当前页</a-button>
          <!--          <a-button @click="importInvoiceReceipt" type="primary" v-if="$authority('importInvoiceReceipt')"> 发票到账明细导入</a-button>-->
          <!--          <a-button @click="invoiceDepositImport" type="primary" v-if="$authority('importInvoiceReceipt')" icon="unordered-list"> 到账明细 </a-button>-->
          <span v-if="invoicePoolData?.settleAvailLimit>0">
          <Balance inline dcflag='d' :amount="invoicePoolData?.settleAvailLimit" prefix="已到账" suffix="元"></Balance>
          <a-button @click="invoicePoolSettle" v-if="$authority('invoiceClearing')" type="link" icon="thunderbolt" size="small">立即清算 </a-button>
          </span>

        </div>
        <div class="tablebox">

          <a-table :columns="columns" :data-source="data" :row-key="(record) => record.id" :pagination="false" bordered
                   size="small" :scroll="{ x: 1700, }" >
            <template slot="action" slot-scope="text, record" v-if="record.invalid==0">
              <a-button
                  type="normal"
                  size="small"
                  v-if="record.normalStatus !== 1 && $authority('invoiceNormal') "
                  @click="normal(record)"
                  aria-label="匹配">
                匹配
              </a-button>
              <a-button
                  type="normal"
                  size="small"
                  v-if="record.clearStatus !== 1 && $authority('invoiceClearing') "
                  @click="clearing(record)"
                  aria-label="清算">
                清算
              </a-button>
              <a-button
                  type="link"
                  size="small"
                  v-if="(record.invoiceType == 1 || record.invoiceType == 2 ) && record.fileNo "
                  @click="invoiceFileView(record)"
                  aria-label="原件">
                原件
              </a-button>
              <a-button
                  type="link"
                  style="color:red"
                  v-if=" $authority('invoiceInvalid') &&  record.normalStatus === 0 && record.clearStatus === 0 "
                  @click="invalid(record)"
                  aria-label="作废操作" icon="delete">
              </a-button>
            </template>
          </a-table>
          当前可用发票金额：<Balance inline :amount="invoicePoolData?.totalLimit"></Balance>
        </div>

        <div class="paginationBox">
          <a-button class="Homepage" :disabled="Number(form.pageNo) == 1" @click="Homepage">
            首页
          </a-button>
          <a-pagination v-model.trim="form.pageNo" :page-size-options="pageSizeOptions" :total="total"
                        show-size-changer :page-size="form.pageSize" @change="pagechange"
                        @showSizeChange="onShowSizeChange"
                        :item-render="itemRender">
          </a-pagination>
          <a-button @click="Trailingpage" :disabled="form.pageNo == Math.ceil(Number(total) / Number(form.pageSize))"
                    class="Trailingpage">
            尾页
          </a-button>
        </div>
      </div>
    </a-card>

    <!--    确认结算框-->
    <!-- 确认结算框 -->
    <a-modal
        title="清算确认"
        :visible="invoicePoolSettleVisible"
        @ok="invoicePoolSettleOk"
        @cancel="invoicePoolSettleCancel"
        width="600px"
    >
      <a-form-model :model="settleForm" size="small" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" layout="horizontal">

        <a-form-item label="结算账户">
          <a-select
              :dropdownMatchSelectWidth="false"
              placeholder="请选择结算账户"
              :disabled="true"
              v-model="settleForm.collAccountNo"
              style="width: 80%">
            <a-select-option v-for="item in shoplist" :key="item.value" :value="item.value">
              <div style="display: flex; justify-content: space-between">
                <span>{{ item.collAccountName }}</span>
                <code style="color: grey;font-size: 0.8em">{{ item.collAccountNo }}</code>
              </div>
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="结算金额">
          <input-balance v-model="settleForm.settleAmount"
                         :max="Number(settleForm.settleAmount)"
                         style="width: 80%"
                         placeholder="结算金额"
                         align-left></input-balance>
        </a-form-item>

      </a-form-model>
    </a-modal>


    <a-modal
        title="发票文件查看"
        :visible="invoiceImgFileVisible"
        @ok="invoiceImgFileVisible = false"
        @cancel="invoiceImgFileVisible = false"
        width="850px"
        :body-style="{ height: '750px', overflow: 'auto' }"
    >
      <img :src="fileUrl" style="width: 100%; height: 100%; object-fit: contain;"/>
    </a-modal>

    <a-modal
        title="是否批量清算以下发票"
        :visible="settleCurrVisible"
        @ok="settleCurrOk"
        @cancel="settleCurrCancel"
        width="85%"
        :body-style="{ height: '750px', overflow: 'auto' }"
    >
      <a-table :columns="columns" :data-source="settleCurrData" :row-key="(record) => record.id" :pagination="false" bordered
               size="small"/>

      <template slot="footer">

        <a-button @click="settleCurrCancel" type="danger">取消</a-button>
        <a-button @click="settleCurrOk" type="primary">批量清算({{ settleCurrData.length }})</a-button>
      </template>
    </a-modal>

    <a-modal
        title="发票清算结果"
        v-model="settleResultVisible"
        width="60%"
        :footer="null"
    >
      <a-descriptions bordered :column="2">
        <a-descriptions-item label="成功数">{{ settleResult.success }}</a-descriptions-item>
        <a-descriptions-item label="失败数">{{ settleResult.fail }}</a-descriptions-item>

        <a-descriptions-item label="错误信息" :span="2">
          <div v-if="settleResult.errors && settleResult.errors.length">
            <div v-for="(err, index) in settleResult.errors" :key="index" style="color:red">
              {{ index + 1 }}. {{ err }}
            </div>
          </div>
          <span v-else style="color: #999">无</span>
        </a-descriptions-item>
      </a-descriptions>

    </a-modal>


  </div>

</template>

<script>
import {BizDict} from "@/utils/bizDict/kvMap";
import {dict_rawdata as busiDict} from "@/utils/bizDict/rawdata";
import Balance from "@/view/components/Balance.vue";
import WalletInfo from '@/view/components/WalletInfo.vue'
import authority from "@/utils/authority";
import DepartmentChoose from "@/view/components/DepartmentChoose.vue";
import moment from "moment";
import {mchshopinvoiceDict} from "@/utils/bizDict/mchshopinvoiceDict";
import InputBalance from "@/view/components/InputBalance.vue";

export default {
  name: 'MchShopInvoice',
  components: {
    InputBalance,
    WalletInfo,
    DepartmentChoose,
    // eslint-disable-next-line vue/no-unused-components
    Balance
  },
  computed: {
    busiDict() {
      return busiDict
    }
  },
  data() {
    return {
      defaultDateRange: [
        moment().startOf('year'),
        moment()
      ],
      pageSizeOptions: ['10', '50'],
      fileList: [],
      selectedShop: {}, // 存储选中店铺的完整信息
      treeData: [],
      statuslist: BizDict.LoanAppStatus,
      settleStatus: mchshopinvoiceDict.settleStatus,
      matchStatus: mchshopinvoiceDict.matchStatus,
      invalidStatus: mchshopinvoiceDict.invalidStatus,
      data: [],
      settleCurrData: [],
      settleCurrVisible: false,
      settleResultVisible: false,
      settleResult: {}, // 保存清算结果

      invoicePoolSettleVisible: false,
      settleForm: {
        settleAmount: 0,
      },
      statisticsData: {
        loanAmountSum: null,
        orderAmount3: null
      },
      invoicePoolData: {
        totalLimit:0,
        settleAvailLimit:0,
    },
      statistics: false,
      fileUrl: '',
      invoiceImgFileVisible: false,
      mchNolist: [], // 电商列表
      shoplist: [], // 店铺列表
      invoiceMonth: this.$moment().startOf("month"),
      total: 0,
      form: {
        normalStatus: '',
        clearStatus: '0',
        invalid: '',
        invoiceNo: '',
        invoiceAmountStart: '',
        invoiceAmountEnd: '99999999',
        registerDateStart: moment().subtract(12, 'months').format("YYYY-MM-DD"),
        registerDateEnd: moment().format("YYYY-MM-DD"),
        mchNo: '', //电商编号
        shopNo: '', // 店铺号
        collAccountNo: '', // 结算账户
        pageNo: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: 'No',
          dataIndex: 'No',
          customRender: (text, record, index) =>
              `${Number(this.form.pageNo - 1) * Number(this.form.pageSize) + Number(index + 1)}`,
          align: 'center',
          width: 70,
        },
        // {
        //   title: '机构',
        //   align: 'center',
        //   dataIndex: 'departmentCode',
        //   width: 80,
        //   ellipsis: true,
        //   customRender: (text) => {
        //     return <DeptInfo deptCode={text} />
        //   }
        // },
        // {
        //   title: '状态',
        //   dataIndex: 'invalid',
        //   align: 'center',
        //   width: 70,
        //   ellipsis: true,
        //   customRender: (text) => {
        //     let invalidStatus = this.invalidStatus.find((item) => (item.value) === String(text))
        //     return <a-tag color={invalidStatus.color}> {invalidStatus.text} </a-tag>
        //   },
        // },
        {
          title: '开票日期',
          align: 'center',
          dataIndex: 'invoiceDate',
          width: 120,
          ellipsis: true,
        },
        {
          title: '发票编号',
          dataIndex: 'invoiceNo',
          align: 'center',
          width: 200,
          ellipsis: true,
        }, {
          title: '类型',
          dataIndex: 'invoiceType',
          width: 50,
          ellipsis: true,
          align: 'center',
          customRender: (text) => {
            if (text == 1) {
              return '专票'
            } else if (text == 2) {
              return '普票'
            } else if (text == 3) {
              return '特殊'
            } else {
              return '其他'
            }
          }
        }, {
          title: '付款方',
          dataIndex: 'purchaserName',
          ellipsis: true,
        },
        {
          title: '开票金额',
          dataIndex: 'totalAmount',
          align: 'center',
          customRender: (text) => {
            return <Balance amount={text}></Balance>
          }
        },
        {
          title: '到账金额',
          dataIndex: 'matchedRefundAmount',
          align: 'center',
          customRender: (text, record) => {
            const settleAmount = record.matchedRefundAmount - record.settleAmount;
            return (
                <span>
                   <Balance  amount={record.matchedRefundAmount}/>
                  {settleAmount >0 && (  <Balance prefix="待清算：￥" dcflag="c" amount={settleAmount}/>)}
                </span>
            );
          }
        },
        {
          title: '清算账户',
          dataIndex: 'settleAccountNo',
          key: 'settleAccountNo',
          align: 'center',
          ellipsis: true,
          customRender: (text, row) => {
            if (!text) {
              return ""
            }
            return <WalletInfo showAccountName={true} showAccountNo={false} accountNo={row.settleAccountNo} accountName={row.settleAccountName}  showBalance={false}/>
          },
        },
        {
          title: '状态',
          dataIndex: 'clearStatus',
          align: 'center',
          width: 200,
          customRender: (text, record) => {
            let matchStatus = this.matchStatus.find((item) => String(item.value) === String(record.normalStatus))
            let settleStatus = this.settleStatus.find((item) => String(item.value) === String(record.clearStatus))
            return <span>
              <a-tag color={matchStatus.color}> {matchStatus.text} </a-tag>
              <a-tag color={settleStatus.color}> {settleStatus.text} </a-tag>
            </span>
          },
        },
        ...(authority('invoiceNormal') || authority('invoiceClearing') || authority('invoiceInvalid') ? [
          {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            width: 250,
            align: 'center',
            fixed: 'right',
            scopedSlots: {customRender: 'action'},
          }
        ] : [])
      ],

    }
  },
  created() {
    this.getMchLiveListApi()
  },
  mounted() {
  },
  activated() {

  },

  methods: {
    filterOption(input, option) {
      let val = input?.trim().toLowerCase()
      if (val.length < 1) return false;
      const children = option.componentOptions.children[0].children.map(m => m.text).filter(m => m)

      return (
          children.find(m => m.toLowerCase().indexOf(val) >= 0)
      );
    },

    // 获取发票文件地址
    async invoiceFileView(data) {
      const res = await this.api.downloadImage(data.fileNo);
      if (res.code !== 200) {
        this.$message.error(res.info);
        return;
      }
      console.log(res.data);

      // 直接使用 isFileType 方法判断类型
      if (this.isImgType(res.data)) {
        this.fileUrl = res.data;
        this.invoiceImgFileVisible = true;
      } else {
        window.open(res.data);
      }
    },

    // 通用文件类型判断方法
    isImgType(fileUrl) {
      // 去除查询参数部分，只保留路径部分
      const cleanUrl = fileUrl.split('?')[0];

      const imageRegex = /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i;

      return imageRegex.test(cleanUrl);

    },


    viewDetails() {
      this.$router.push({
        path: '/orders/Summaryorder',
        query: {
          invoiceDate: this.form.registerDateEnd,
          mchNo: this.form.mchNo,
          shopNo: this.form.shopNo,
          pageNo: this.form.pageNo,
          pageSize: this.form.pageSize,
        },
      })
    },

    //匹配
    async normal(data) {
      this.$router.push({
        path: '/Mch/MchShopInvoiceNormal',
        query: {
          id: data.id,
          mchNo: this.form.mchNo,
          shopNo: this.form.shopNo,
          pageNo: this.form.pageNo,
          pageSize: this.form.pageSize,
        },
      })
    },
    //清算
    async clearing(data) {
      const res = await this.api.mchShopInvoiceSettleApi(data.id)
      if (res.code !== 200) {
        this.$message.error(res.info)
        return
      }
      this.$message.info(res.info)
      await this.getList()
    },
    //作废
    async invalid(data) {
      const res = await this.api.mchShopInvoiceInvalidApi([data.id])
      if (res.code !== 200) {
        this.$message.error(res.info)
        return
      }
      await this.getList()
    },
    // 获取table列表
    async getList() {
      // 检查必填项
      if (!this.form.registerDateStart || !this.form.registerDateEnd || !this.form.mchNo || !this.form.collAccountNo) {
        return
      }
      const res = await this.api.mchShopInvoiceListApi(this.form)
      if (res.code !== 200) {
        this.$message.error(res.info)
        return false
      }
      this.total = res.data.total
      this.form.pageNo = res.data.current
      this.form.pageSize = res.data.size

      this.data = res.data.records
      this.statistics = true
      return true
    },

    async getPoolList() {

      const res = await this.api.mchShopInvoicePoolQueryApi(this.form)

      if (res.code !== 200) {
        this.invoicePoolData= {}
      }

      this.invoicePoolData= res.data
    },

    async invoicePoolSettle() {
      this.settleForm.settleAmount = this.invoicePoolData?.settleAvailLimit
      this.settleForm.collAccountNo = this.form?.collAccountNo
      this.invoicePoolSettleVisible = true
    },

    async invoicePoolSettleOk() {
      const res = await this.api.mchShopInvoicePoolSettleApi({...this.settleForm, ...this.form})

      if (res.code !== 200) {
        this.$alert(`清算失败或仍在进行中，请勿频繁重复清算，若持续失败请联系银行。当前原因：${res.info}`)
        return
      }
      this.invoicePoolSettleVisible = false
      this.getPoolList()
    },

    invoicePoolSettleCancel() {
      this.settleAvailLimit = 0
      this.invoicePoolSettleVisible = false
    },
    async handleSyncAll() {

      this.$confirm({
        title: "确认执行全量同步？",
        content: "将从发票池拉取并同步所有可同步发票状态，请确认是否执行。",
        onOk: async () => {
          const res = await this.api.mchShopInvoiceSyncAllApi(this.form);
          if (res.code !== 200) {
            this.$message.error(res.info || "同步失败");
            return;
          }
          this.$message.success("同步完成");

          // 刷新列表和额度
          await this.search();


        }
      });

    },



    onChange(date, dateString) {
      this.form.registerDateStart = dateString[0]
      this.form.registerDateEnd = dateString[1]
      console.log(this.form)
      this.search()
    },
    // 获取电商信息列表
    async getMchLiveListApi() {
      this.mchNolist = [];
      const res = await this.api.mchshopsApi({
        pageNo: 1,
        pageSize: 10000,
        goodsTypes: ['50','51'],
        departmentCode: this.form.departmentCode,
        mchType: 1, //默认融资电商
      });
      if (res.code !== 200) {
        this.$message.error(res.info);
        return;
      }
      // mchNolist
      this.mchNolist = res.data.records.map(x => Object.assign(x, {
        label: x.mchName,
        value: x.mchNo
      }))
      // 默认选中第一个
      if (this.mchNolist.length > 0) {
        this.form.mchNo = this.mchNolist[0].value
        await this.getMchShopListApi(this.form.mchNo)
      }
    },
    async departmentChange() {
      await this.getMchLiveListApi()
    },
    // 获取店铺信息列表
    async getMchShopListApi() {
      this.shoplist = [];
      const res = await this.api.managerpageApi({
        pageNo: 1,
        pageSize: 10000,
        mchNo: this.form.mchNo, //默认融资电商
      });
      if (res.code !== 200) {
        this.$message.error(res.info);
        return;
      }

      const shops = res.data.records.filter(x => x.collAccountNo).reduce((acc, cur) => {
        const existingItem = acc.find(item => item.collAccountNo === cur.collAccountNo);
        if (!existingItem) {
          acc.push(cur);
        }
        return acc;
      }, []);

      this.shoplist = shops.map(x => Object.assign(x, {
        label: x.collAccountName,
        value: x.collAccountNo
      }))

      // 默认选中第一个
      if (this.shoplist.length > 0) {
        this.form.collAccountNo = this.shoplist[0].value
        await this.search()

      } else {
        this.form.collAccountNo = ''
      }
    },

    // 点击重置表单
    reset() {
      // 先重置
      this.data = []
      this.form.pageNo = 1
    },

    // 改变当前页的事件函数
    onShowSizeChange(current, pageSize) {
      this.form.pageSize = pageSize
      this.getList()
    },
    // 修改上一页和下一页为文字链接
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return <a>上一页</a>
      } else if (type === 'next') {
        return <a>下一页</a>
      }
      return originalElement
    },
    // 首页
    Homepage() {
      if (this.total == 0) {
        return
      }
      this.form.pageNo = 1
      this.getList()
    },
    // 尾页
    Trailingpage() {
      if (this.total == 0) {
        return
      }
      this.form.pageNo = Math.ceil(Number(this.total) / Number(this.form.pageSize))

      this.getList()
    },
    pagechange(val) {
      this.form.pageNo = val
      this.getList()
    },
    // 搜索查询
    async search() {
      // 先重置
      this.data = []
      this.form.pageNo = 1
      await this.getList()
      await this.getPoolList()
    },

    // 新增发票
    add() {
      this.$router.push({
        path: '/Mch/MchShopInvoiceAdd',
        query: {
          invoiceDate: this.form.registerDateEnd,
          mchNo: this.form.mchNo,
          shopNo: this.form.shopNo,
          pageNo: this.form.pageNo,
          pageSize: this.form.pageSize,
        }
      })
    },

    // 发票到账明细导入


    async invoiceDepositImport() {
      this.$router.push({
        path: '/Mch/MchShopInvoiceDepositImport',
        query: {
          invoiceDate: this.form.registerDateEnd,
          mchNo: this.form.mchNo,
          shopNo: this.form.shopNo,
          pageNo: this.form.pageNo,
          pageSize: this.form.pageSize,
        }
      })
    },
    //清算当前页
    settleCurrPage: async function () {
      //筛选 可清算 的发票
      this.settleCurrData = this.data.filter(x => (x.matchedRefundAmount - x.settleAmount) > 0);

      if (this.settleCurrData.length == 0) {
        this.$message.warning("没有可清算的发票");
        return;
      }
      this.settleCurrVisible = true
    },

    settleCurrOk: async function () {
      const invoiceNos = this.settleCurrData.map(x => x.invoiceNo);

      if (invoiceNos.length === 0) {
        this.$message.warning("没有可清算的发票");
        return;
      }

      const res = await this.api.mchShopInvoiceSettleBatchApi(invoiceNos);
      if (res.code !== 200) {
        this.$message.error(res.info);
        return;
      }
      // 存储并展示结果
      this.settleResult = res.data;
      this.settleResultVisible = true;

      // 清理数据
      this.settleCurrVisible = false;
      this.settleCurrData = [];

      await this.getList();
    },

    settleCurrCancel: async function () {
      this.settleCurrVisible = false
      this.settleCurrData = []
    },



    async getShopList() {
      this.shoplist = [];
      const res = await this.api.managerpageApi({
        pageNo: 1,
        pageSize: 10000,
        mchType: 1,
        mchNo: this.form.mchNo
      });
      if (res.code !== 200) {
        this.$message.error(res.info);
        return;
      }
      this.shoplist = res.data.records;
    },
    //删除上传文件
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();

      newFileList.splice(index, 1);

      this.fileList = newFileList;
    },
    async beforeUpload(info) {
      this.fileList = [];
      this.fileList.push(info.file);
    },

  },
}
</script>
<style>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
</style>
<style lang="less" scoped>
.ant-card-head-title {
  font-size: 14px;
  font-weight: 600;
}

.right-flex {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .selectors {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .statistics-summary {
    font-size: 12px;
    color: #333;
    text-align: left;
    margin-top: 10px;

    p {
      margin: 0;
    }


  }
}


/* 自定义表头样式 */
.ant-table-thead > tr > th {
  background-color: #f2f2f2;
}

.ant-modal-footer {

  padding-bottom: 20px;
}

.ant-modal-content {
  width: 420px;
}


.loan {

  .text-center {
    text-align: center;
    padding-top: 40px;
  }

  .paginationBox {
    display: flex;
    margin-top: 20px;
    justify-content: center;

    // .ant-pagination-options {
    //   float: left;
    // }

    .ant-pagination-prev,
    .ant-pagination-next,
    .ant-pagination-jump-prev,
    .ant-pagination-jump-next {
      border: 1px solid #d9d9d9;
      width: 60px;
    }
  }

  .Applyfor {
    padding-top: 10px;
    margin-bottom: 20px;
  }
}

// 贷款弹窗
.Openanaccount {
  padding: 30px;

  .personage {
    width: 100%;
    height: 40px !important;
    border-radius: 8px;
    background-color: #555555;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    margin-bottom: 30px;
  }

  .firm {
    width: 100%;
    height: 40px;
    border-radius: 8px;
    background-color: #555555;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    margin-bottom: 20px;
  }
}

/deep/ .ant-card-head-title {
  .top-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 20px;
    flex-wrap: wrap;

    .dianshang {
      margin-left: 50px;
    }
  }
}


</style>
